import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../index';

const initialState = {
  mfaSetting: {
    verificationToken: null,
    method: null,
    mfaMethods: [],
    mfaMode: null, // Indicates the mode of Create MFA Method, used to render different wordings in CreateMfaMethodDialog.js
    mfaCreateMethod: null
  }
};

const slice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    createMfaVerificationTokenSuccess(state, action) {
      state.mfaSetting.verificationToken = action.payload;
    },
    challengeSuccess(state, action) {
      state.mfaSetting.method = action.payload;
    },
    getMfaMethodsSuccess(state, action) {
      state.mfaSetting.mfaMethods = action.payload;
    },
    setMfaMode(state, action) {
      state.mfaSetting.mfaMode = action.payload;
    },
    setMfaCreateMethod(state, action) {
      state.mfaSetting.mfaCreateMethod = action.payload;
    },
    getMfaPhoneCountryCodeListSuccess(state, action) {
      state.mfaSetting.phoneCountryCodeList = action.payload;
    }
  }
});

export default slice.reducer;

export function updateUserProfile(profile = {}) {
  return async () => {
    return await axios.put(`/synergy/accounts/self`, profile);
  };
}

export function createMfaVerificationToken(username) {
  return async () => {
    const response = await axios.post(`/synergy/oauth/verifications`, {
      type: 'MFA_METHOD_OPT_IN',
      parameters: [
        {
          key: 'username',
          value: username
        }
      ]
    });
    dispatch(slice.actions.createMfaVerificationTokenSuccess(response.data?.token));
    return response.data?.token;
  };
}

export function challenge(verificationToken, method) {
  return async () => {
    const response = await axios.post(`/synergy/oauth/challenge`, {
      challengeType: 'push-code',
      verificationToken,
      communicationMethod: method
    });
    dispatch(slice.actions.challengeSuccess(response.data?.method));
  };
}

export function createMfaMethod(verificationToken, otp) {
  return async () => {
    return await axios.post(`/synergy/accounts/self/mfa-methods`, {
      verificationToken,
      otp
    });
  };
}

export function getMfaMethods() {
  return async () => {
    const response = await axios.get(`/synergy/accounts/self/mfa-methods`);
    dispatch(slice.actions.getMfaMethodsSuccess(response.data));
  };
}

export function deleteMfaMethod(id) {
  return async () => {
    return await axios.delete(`/synergy/accounts/self/mfa-methods/${id}`);
  };
}

export function setMfaMode(mode) {
  return async () => {
    dispatch(slice.actions.setMfaMode(mode));
  };
}

export function setMfaCreateMethod(method) {
  return async () => {
    dispatch(slice.actions.setMfaCreateMethod(method));
  };
}

export function getMfaPhoneCountryCodeList() {
  return async () => {
    const response = await axios.get(`/synergy/utilities/phone-calling-codes`);
    dispatch(slice.actions.getMfaPhoneCountryCodeListSuccess(response.data));
  };
}
